<template>
  <VueHeader :currentTab="currentTab" @setTab="currentTab = $event" :tabs="tabs">
  </VueHeader>

  <div class="container">
    <router-view v-slot="{ Component }">
      <transition name="fade">
        <component :is="Component" />
      </transition>
    </router-view>
  </div>

  <VueFooter />
</template>
<style>

.container {
  justify-content: center;
  align-items: center;
  margin: 100px auto 0 auto;
  max-width: 940px;
  padding: 0 10px;
}

@media screen and (max-width: 800px) {
  .container {
    padding: 0 20px;
  }
}



a.button {
  margin: 0 10px;
  padding: 10px 20px;
  background-color: #333;
  color: white;
  text-decoration: none;
  border-radius: 5px;
  cursor: pointer;
  user-select: none;
}

#app{
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #464849;
}
body {
  margin: 0 !important;
  padding: 0 !important;
  background-color: #131517;
}
</style>
<script>
import VueHeader from "@/components/Header.vue";
import VueFooter from "@/components/Footer.vue";
export default {
  name: 'App',
  components: {
    VueHeader,
    VueFooter,
  },
  data() {
    return {
      currentTab: 0,
      tabs: [
        {
          name: "Home",
          link: "home",
        },
        {
          name: "Testo Cantico",
          link: "testo-cantico",
        },
        {
          name: "Vita",
          link: "vita",
        },
        {
          name: "Natura",
          link: "natura",
        },
        {
          name: "Limiti",
          link: "limiti",
        },
        {
          name: "Misericordia",
          link: "misericordia",
        },
      ]
    }
  }
}
</script>